import { Link } from "react-router-dom";
import { Shirt, Heart, Watch, Crown, Footprints, Flame } from "lucide-react";

export const SHOP_CATEGORIES = [
  { value: "hombre", label: "Hombre", icon: Shirt, color: "#00FF66" },
  { value: "mujer", label: "Mujer", icon: Heart, color: "#B026FF" },
  { value: "accesorios", label: "Accesorios", icon: Watch, color: "#22d3ee" },
  { value: "gorras", label: "Gorras", icon: Crown, color: "#fbbf24" },
  { value: "zapatos", label: "Zapatos", icon: Footprints, color: "#f472b6" },
  { value: "ofertas", label: "Liquidacion", icon: Flame, color: "#ef4444" },
];

export const CategorySquares = ({ active }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4" data-testid="category-squares">
    {SHOP_CATEGORIES.map(({ value, label, icon: Icon, color }) => {
      const isActive = active === value;
      return (
        <Link
          key={value}
          to={`/categoria/${value}`}
          className="glass-card aspect-square flex flex-col items-center justify-center gap-3 transition-all duration-300 hover:-translate-y-1"
          style={{
            borderColor: isActive ? color : undefined,
            boxShadow: isActive ? `0 0 24px ${color}55` : undefined,
          }}
          data-testid={`category-square-${value}`}
        >
          <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ backgroundColor: `${color}1f` }}>
            <Icon className="w-8 h-8" style={{ color }} />
          </div>
          <span className="font-oswald text-lg sm:text-xl font-bold text-white uppercase tracking-wide">{label}</span>
        </Link>
      );
    })}
  </div>
);
